import resilenderLogo from "../../../../../assets/resilender-logo.png"; // Adjust the path as necessary
import resfinLogo from "../../../../../assets/resfin-logo.png"; // Adjust the path as necessary
import lendmarqLogo from "../../../../../assets/logos/lendmarq-logo.png"; // Adjust the path as necessary
import PdfImage from "../../components/images/PdfImage";
import { useEnv } from "../../../../../hooks/useEnv";

const PdfBuilderLogo = ({ width, height, size = 32, style = {} }) => {
  const { isResfin, isLendmarq } = useEnv();

  if (isLendmarq) {
    const logoWidth = 105;
    const logoHeight = logoWidth / 5.37037037037;
    return (
      <PdfImage
        src={lendmarqLogo}
        width={width || logoWidth}
        height={height || logoHeight}
        style={style}
      />
    );
  }
  if (isResfin) {
    return (
      <PdfImage
        src={resfinLogo}
        width={width || size}
        height={height || size / 1.225}
        style={style}
      />
    );
  }
  return (
    <PdfImage src={resilenderLogo} width={size} height={size} style={style} />
  );
};

export default PdfBuilderLogo;
